module.exports = __webpack_public_path__ + "static/media/unionpay.ee2d12c4.svg";